var _defs, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHome(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 800 800",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;fill-rule:evenodd;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M377,59.2a33.32,33.32,0,0,1,46,0l266.67,254L773,392.53a33.33,33.33,0,1,1-46,48.27l-27-25.72V666.67a66.66,66.66,0,0,1-66.67,66.66H166.67A66.66,66.66,0,0,1,100,666.67V415.08L73,440.8a33.33,33.33,0,1,1-46-48.27l83.33-79.37ZM166.67,351.59V666.67H300V500a100,100,0,0,1,200,0V666.67H633.33V351.59L400,129.36ZM433.33,666.67V500a33.33,33.33,0,0,0-66.66,0V666.67Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/Home.22944209d0b00aab3b95c1c78f774089.svg";
export { ForwardRef as ReactComponent };